// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Map, List, OrderedMap } from 'immutable'
import ConverterContext from './ConverterContext'
import { isFunction } from 'lodash'

// Currently we only need thess two hooks
export const AFTER_APPEND_BLOCKS_HOOK = 'afterAppendBlocks'
export const BEFORE_TO_RAW_HOOK = 'beforeToRaw'
export const BEFORE_FROM_HTML = 'beforeFromHTML'
export const AFTER_FROM_HTML = 'afterFromHTML'

const middlewareTypeKeys = {
  [AFTER_APPEND_BLOCKS_HOOK]: true,
  [BEFORE_TO_RAW_HOOK]: true,
  [AFTER_FROM_HTML]: true,
  [BEFORE_FROM_HTML]: true,
}

const DEFAULT_CONVERTER = '__fallback'

const defaultExportOptions = {
  removeEmptyParagraphs: false,
}

export default class Factory {
  constructor() {
    this._ansTypeConverterMap = {}
    this._draftTypeConverterMap = {}
    this._middlewares = {}
    this._middlewares[BEFORE_TO_RAW_HOOK] = []
    this._middlewares[AFTER_APPEND_BLOCKS_HOOK] = []
    this._middlewares[AFTER_FROM_HTML] = []
    this._middlewares[BEFORE_FROM_HTML] = []
  }

  getMiddlewares(middleware) {
    return this._middlewares[middleware] || []
  }

  addConverter(converter) {
    if (converter && converter.getAnsType() && converter.getDraftTypes()) {
      this._ansTypeConverterMap[converter.getAnsType()] = converter
      converter.getDraftTypes().forEach((draftType) => {
        this._draftTypeConverterMap[draftType] = converter
      })
    }
  }

  addMiddleware(hookType, middleware) {
    if (isFunction(middleware) && this._middlewares[hookType]) {
      this._middlewares[hookType].push(middleware)
    }
  }

  toDraftContent(contentElements = [], props = {}) {
    const converterContext = new ConverterContext(this)
    const { emptyBlock = false } = props

    contentElements.forEach((element) => {
      const converter =
        this._ansTypeConverterMap[element.type] ||
        this._ansTypeConverterMap[DEFAULT_CONVERTER]
      let insertedBlocks = converter.toBlocks(element, converterContext)

      if (insertedBlocks && insertedBlocks.length) {
        this.getMiddlewares(AFTER_APPEND_BLOCKS_HOOK).forEach((middleware) => {
          insertedBlocks = middleware.apply(this, [
            element,
            insertedBlocks,
            converterContext,
          ])
        })
      }
    })

    return converterContext.generateDraftContent(emptyBlock)
  }

  toAnsList(contentState, options = defaultExportOptions) {
    let blockMap = contentState.getBlockMap()
    if (options.removeEmptyParagraphs) {
      blockMap = blockMap.filter((block) => {
        if (block.getType() === 'atomic') {
          return true
        }
        return block.getText().trim().length > 0
      })
      contentState = contentState.set('blockMap', blockMap)
    }
    return this.toAnsListByBlockMap(contentState, blockMap).map(
      (data) => data.ansData
    )
  }

  toAnsListByBlockMap(contentState, blockMap) {
    let ansList = List()
    let skipWhile
    while (true) {
      const blockMapForCall = skipWhile
        ? blockMap.skipWhile((_, key) => key !== skipWhile).skip(1)
        : blockMap
      const result = this.toAnsListByBlock(
        contentState,
        blockMapForCall,
        skipWhile
      )
      if (!result) {
        break
      }
      skipWhile = result.blockKey
      ansList = ansList.push({
        ansData: result.ansData,
        consumedBlockKeys: [skipWhile].concat(
          blockMapForCall
            .takeWhile((_, key) => key !== skipWhile)
            .keySeq()
            .toJS()
        ),
      })
    }
    return ansList
  }

  toAnsListByBlock(contentState, blockMap, skipWhile) {
    let blocks = []
    let result = null
    blockMap.forEach((block, blockKey) => {
      this.getMiddlewares(BEFORE_TO_RAW_HOOK).forEach((middleware) => {
        const newStates = middleware.apply(this, [contentState, block])
        contentState = newStates.contentState
        block = newStates.block
      })
      const type = block.getType()
      let converter
      if (type === 'atomic') {
        // If it's atomic block, look for explicit ellipsis type converter
        const ellipsisType = (block.getData() || Map()).get('ellipsisType')
        if (ellipsisType) {
          converter = this._draftTypeConverterMap[`${type}-${ellipsisType}`]
        }
      }

      if (!converter) {
        // Looks for block type converter if no explicit converters found
        converter = this._draftTypeConverterMap[type]
      }

      if (!converter) {
        throw Error(`No converter for block ${blockKey}: ${block.getType()}`)
      }

      blocks.push(block)
      // shouldAggregate uses lookahead logic
      const nextBlock = contentState.getBlockAfter(blockKey)
      // Check if we should aggregate the blocks array for conversion call
      if (!nextBlock || !converter.shouldAggregate(blocks, nextBlock)) {
        const ansData = converter.toAns(contentState, blocks)
        result = {
          ansData,
          blockKey,
        }
        return false
      }
    })
    return result
  }
}
